<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'StripeConnectBlock',
  props: {
    iconName: String,
    title: String,
    bullets: Array,
  },

  data() {
    return {

    };
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id }),
    ...mapState('contractor', { contractorId: (state) => state.id }),
    ...mapGetters(['isSwitched', 'userAuthenticator', 'authAuthenticator']),
  },
  mounted() {

  },

  methods: {
    getIconPath(name) {
      const context = require.context('@/assets/img/icons', false, /.svg$/);
      return context(`./${name}.svg`);
    },
  },
};

</script>

<template>
  <div>
    <div>
      <img v-if="iconName" class="icon" :src="getIconPath(iconName)" alt="Icon" />
      <p class="title" v-if="title">{{title}}</p>
    </div>
    <ul >
      <li v-for="(bullet, index) in this.bullets" :key="index" >{{bullet}}</li>
    </ul>
  </div>
</template>

<style scoped lang="styl">
.stripe-connect .block{
  padding-right:20px;
  width: 25%;
}
.block .title{
  font-size:20px;
  line-height: 140%;
  color:#293033;
  font-weight: 700;
  margin-top:20px;
  height: 60px;
  margin-bottom:16px;
}
.icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
  object-position: center;
}
@media screen and (max-width: 1578px) {
  .block .title {
    height: 90px;
  }
}
@media screen and (max-width: 1402px) {
  .block .title {
    height: 115px;
  }
}
@media screen and (max-width: 1377px) {
  .block .title {
    height: 60px;
  }
}

@media screen and (max-width: 1023px) {
  .stripe-connect .block span {
    flex-direction: row;
    display: flex;
  }
  .icon {
    margin-right: 10px;
  }
  @media screen and (max-width: 769px) {
    .stripe-connect .block ul {
      margin-top: 20px;
    }
  }
  @media screen and (max-width: 600px) {
    .block .title{
      height: auto;
    }
    .stripe-connect .block ul {
      margin-top: 10px;
    }
    .icon {
      width: 40px;
      height: 40px;
    }
    .block .title {
      height: auto;
      font-size: 16px;
      line-height: 22.4px;
      margin-top:16px;
    }
  }
}

</style>
